import React from 'react';
import { ArrowUp, MessageCircle, MapPin } from 'lucide-react';
import Logo from '../common/Logo';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-[#f5f5f7] border-t border-[#d2d2d7]">
      <div className="container mx-auto px-6">
        {/* Top row */}
        <div className="py-12 flex flex-col md:flex-row items-center md:items-start justify-between gap-10">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start gap-4 text-center md:text-left">
            <Logo className="h-9 text-[#1d1d1f]" />
            <p className="text-[13px] text-[#86868b] max-w-xs leading-relaxed">
              Premium Technology. Unmatched Experience.
              <br />
              Retail &amp; wholesale, done right.
            </p>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <h4 className="text-[12px] font-bold tracking-[0.2em] uppercase text-[#1d1d1f]">
              Get in touch
            </h4>
            <a
              href="https://wa.me/96178872863"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[13px] text-[#86868b] hover:text-[#1d1d1f] transition-colors"
            >
              <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
              WhatsApp us
            </a>
            <span className="inline-flex items-center gap-2 text-[13px] text-[#86868b]">
              <MapPin className="w-4 h-4" strokeWidth={1.5} />
              Lebanon
            </span>
          </div>

          {/* Back to top */}
          <button
            onClick={scrollToTop}
            className="group inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-[#d2d2d7] rounded-full text-[13px] font-semibold text-[#1d1d1f] hover:bg-[#1d1d1f] hover:text-white hover:border-[#1d1d1f] transition-all duration-300 active:scale-95 shadow-sm"
          >
            <ArrowUp className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-0.5" strokeWidth={2} />
            Back to top
          </button>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-[#d2d2d7] flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[12px] text-[#86868b]">
            Copyright © {new Date().getFullYear()} iSeries Inc. All rights reserved.
          </p>
          <p className="text-[11px] tracking-[0.2em] uppercase text-[#86868b]/70 font-medium">
            Premium Retail &amp; Wholesale
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
